<template>
  <MembershipBannerBar v-if="!userStore.isFullMember()">
    Full members see viewing options for <i>all</i> ceremonies.
  </MembershipBannerBar>

  <div class="container mol-typical-page-container-10" :class="{'showing-message-banner': !userStore.isFullMember()}">

    <div class="d-grid gap-2 d-flex justify-content-end">
      <button class="btn btn-sm btn-outline-primary" type="button" @click="showFilterModal">
        <i class="fa fa-filter"></i> {{filterButtonText}}
      </button>
      <GenericModal v-if="show_filter_modal" @modal-closed="show_filter_modal=false">
        <template #header>
          <h6 style="text-align: center;"><i class="fa fa-filter"></i> filter films</h6>
        </template>

        <div class="row">
            <div v-for="(genre) in genreList" :key="genre" class="col-6 filter-toggle">
              <span class="btn btn-outline-secondary btn-sm btn-filter-checkbox" type="button" @click="toggleGenreFilter(genre)">
                <span v-if="filteredByGenres.includes(genre)" class="fa fa-check" aria-hidden="true"></span>
              </span>
              <span :style="filteredByGenres.includes(genre)? 'font-weight: bolder;' : ''" @click="toggleGenreFilter(genre)"> {{genre}}</span>
            </div>
        </div>

        <hr>

        <div class="col-6 filter-toggle">
          <span class="btn btn-outline-secondary btn-sm btn-filter-checkbox" type="button" @click.stop="hideViewedFilms = !hideViewedFilms">
            <span v-if="hideViewedFilms" class="fa fa-check" aria-hidden="true"></span>
          </span>
          <span :style="hideViewedFilms? 'font-weight: bolder;' : ''" @click="hideViewedFilms = !hideViewedFilms"> <i class="fa fa-eye-slash"></i> hide viewed films</span>
        </div>
      </GenericModal>
    </div>

    <hr>

    <div class="row">

      <!----------------------------------------------
          LOCAL THEATERS
       ----------------------------------------------->

      <!--
      <div class="col-xxl-3 col-lg-4 col-md-6">
        <ShortsInTheatersPromoFilmListCard :hideViewedFilms="hideViewedFilms" :filterByGenres="filteredByGenres">
        </ShortsInTheatersPromoFilmListCard>
      </div>
      -->

      <div class="col-xxl-3 col-lg-4 col-md-6">
        <LocalTheaterFilmListCard :hideViewedFilms="hideViewedFilms" :filterByGenres="filteredByGenres">
        </LocalTheaterFilmListCard>
      </div>



      <!----------------------------------------------
          NETWORK SCHEDULES
       ----------------------------------------------->

      <div v-if="userStore.isFullMember()" class="col-xxl-3 col-lg-4 col-md-6">
        <ScheduledFilmListCard provider="tcm" :hideViewedFilms="hideViewedFilms" :filterByGenres="filteredByGenres">
          <ColorThemeImg :src="logoPathTo('tcm-logo.svg')" :dark_theme_src="logoPathTo('tcm-logo-dark.svg')" alt="tcm logo" height="20"/>
        </ScheduledFilmListCard>
      </div>

      <div v-if="userStore.isFullMember()" class="col-xxl-3 col-lg-4 col-md-6">
        <ScheduledFilmListCard provider="fmc" :hideViewedFilms="hideViewedFilms" :filterByGenres="filteredByGenres">
          <ColorThemeImg :src="logoPathTo('fmc-logo.svg')" :dark_theme_src="logoPathTo('fmc-logo-dark.svg')" alt="tcm logo" height="20"/>
        </ScheduledFilmListCard>
      </div>

      <div v-if="userStore.isFullMember()" class="col-xxl-3 col-lg-4 col-md-6">
        <ScheduledFilmListCard provider="AMC" :hideViewedFilms="hideViewedFilms" :filterByGenres="filteredByGenres">
          <ColorThemeImg :src="logoPathTo('amc-logo.svg')" :dark_theme_src="logoPathTo('amc-logo-dark.svg')" alt="Logo" height="20"/>
        </ScheduledFilmListCard>
      </div>

      <div v-if="userStore.isFullMember()" class="col-xxl-3 col-lg-4 col-md-6">
        <ScheduledFilmListCard provider="FXM" :hideViewedFilms="hideViewedFilms" :filterByGenres="filteredByGenres">
          <ColorThemeImg :src="logoPathTo('fxm-logo.svg')" :dark_theme_src="logoPathTo('fxm-logo-dark.svg')" alt="Logo" height="20"/>
        </ScheduledFilmListCard>
      </div>


      <!----------------------------------------------
          STREAMING SERVICES
       ----------------------------------------------->

<!--
      <div class="col-xxl-3 col-lg-4 col-md-6">
        <PurchaseAndRentalFilmListCard :hideViewedFilms="hideViewedFilms" :filterByGenres="filteredByGenres">
        </PurchaseAndRentalFilmListCard>
      </div>
-->

      <div class="col-xxl-3 col-lg-4 col-md-6">
        <StreamingFilmListCard provider="Netflix" providerId="8" :hideViewedFilms="hideViewedFilms" :filterByGenres="filteredByGenres">
          <img :src="logoPathTo('netflix-logo.svg')" alt="Logo" height="20">
        </StreamingFilmListCard>
      </div>

      <div class="col-xxl-3 col-lg-4 col-md-6">
        <StreamingFilmListCard provider="Amazon Prime Video" providerId="9" :hideViewedFilms="hideViewedFilms" :filterByGenres="filteredByGenres">
          <ColorThemeImg :src="logoPathTo('prime-video-logo.svg')" :dark_theme_src="logoPathTo('prime-video-logo-dark.svg')" alt="Logo" height="20"/>
        </StreamingFilmListCard>
      </div>

      <div class="col-xxl-3 col-lg-4 col-md-6">
        <StreamingFilmListCard provider="Disney Plus" providerId="337" :hideViewedFilms="hideViewedFilms" :filterByGenres="filteredByGenres">
          <ColorThemeImg :src="logoPathTo('disney-plus-logo.svg')" :dark_theme_src="logoPathTo('disney-plus-logo-dark.svg')" alt="Logo" height="20"/>
        </StreamingFilmListCard>
      </div>

      <div class="col-xxl-3 col-lg-4 col-md-6">
        <StreamingFilmListCard provider="HBO Max" providerId="1899" :hideViewedFilms="hideViewedFilms" :filterByGenres="filteredByGenres">
          <ColorThemeImg :src="logoPathTo('hbo-max-logo.svg')" :dark_theme_src="logoPathTo('hbo-max-logo-dark.svg')" alt="Logo" height="20"/>
        </StreamingFilmListCard>
      </div>

      <div class="col-xxl-3 col-lg-4 col-md-6">
        <StreamingFilmListCard provider="Criterion Channel" providerId="258" :hideViewedFilms="hideViewedFilms" :filterByGenres="filteredByGenres">
          <ColorThemeImg :src="logoPathTo('criterion-channel-logo.svg')" :dark_theme_src="logoPathTo('criterion-channel-logo-dark.svg')" alt="Logo" height="20"/>
        </StreamingFilmListCard>
      </div>

<!-- REMOVING PARAMOUNT PLUS, AS IT'S NOW SPLIT INTO TWO SUBSCRIPTIONS (PREMIUM & ESSENTIAL), EACH WITH SOME UNIQUE FILMS. SO UNTIL I FIGURE THAT OUT, I'M REMOVING IT FROM THE VIEWING OPTIONS PAGE
      <div class="col-xxl-3 col-lg-4 col-md-6">
        <StreamingFilmListCard provider="Paramount Plus" providerId="531" :hideViewedFilms="hideViewedFilms" :filterByGenres="filteredByGenres">
          <ColorThemeImg :src="logoPathTo('paramount-plus-logo.svg')" :dark_theme_src="logoPathTo('paramount-plus-logo-dark.svg')" alt="Logo" height="20"/>
        </StreamingFilmListCard>
      </div>
-->

      <div class="col-xxl-3 col-lg-4 col-md-6">
        <StreamingFilmListCard provider="Hulu" providerId="15" :hideViewedFilms="hideViewedFilms" :filterByGenres="filteredByGenres">
          <img :src="logoPathTo('hulu-logo.svg')" alt="Logo" height="20">
        </StreamingFilmListCard>
      </div>

      <div class="col-xxl-3 col-lg-4 col-md-6">
        <StreamingFilmListCard provider="Peacock Premium" providerId="386" :hideViewedFilms="hideViewedFilms" :filterByGenres="filteredByGenres">
          <ColorThemeImg :src="logoPathTo('peacock-logo.svg')" :dark_theme_src="logoPathTo('peacock-logo-dark.svg')" alt="Logo" height="20"/>
        </StreamingFilmListCard>
      </div>

      <div class="col-xxl-3 col-lg-4 col-md-6">
        <StreamingFilmListCard provider="Apple TV" providerId="350" :hideViewedFilms="hideViewedFilms" :filterByGenres="filteredByGenres">
          <ColorThemeImg :src="logoPathTo('apple-tv-logo.svg')" :dark_theme_src="logoPathTo('apple-tv-logo-dark.svg')" alt="Logo" height="20"/>
        </StreamingFilmListCard>
      </div>

      <div class="col-xxl-3 col-lg-4 col-md-6">
        <StreamingFilmListCard provider="MUBI" providerId="11" :hideViewedFilms="hideViewedFilms" :filterByGenres="filteredByGenres">
          <ColorThemeImg :src="logoPathTo('mubi-logo.svg')" :dark_theme_src="logoPathTo('mubi-logo-dark.svg')" alt="Logo" height="20"/>
        </StreamingFilmListCard>
      </div>

      <div class="col-xxl-3 col-lg-4 col-md-6">
        <StreamingFilmListCard provider="ShortsTV Amazon Channel" providerId="688" :hideViewedFilms="hideViewedFilms" :filterByGenres="filteredByGenres">
          <ColorThemeImg :src="logoPathTo('shorts-tv-logo.svg')" :dark_theme_src="logoPathTo('shorts-tv-logo-dark.svg')" alt="Logo" height="20"/>
        </StreamingFilmListCard>
      </div>

      <div class="col-xxl-3 col-lg-4 col-md-6">
        <StreamingFilmListCard provider="Tubi TV" providerId="73" :hideViewedFilms="hideViewedFilms" :filterByGenres="filteredByGenres">
          <ColorThemeImg :src="logoPathTo('tubi-logo-purple.svg')" :dark_theme_src="logoPathTo('tubi-logo-yellow.svg')" alt="Logo" height="20"/>
        </StreamingFilmListCard>
      </div>

      <!----------------------------------------------
          LIBRARY-CONNECTED STREAMING SERVICES
       ----------------------------------------------->

      <div class="col-xxl-3 col-lg-4 col-md-6">
        <StreamingFilmListCard provider="Kanopy" providerId="191" :hideViewedFilms="hideViewedFilms" :filterByGenres="filteredByGenres">
          <ColorThemeImg :src="logoPathTo('kanopy-logo.svg')" :dark_theme_src="logoPathTo('kanopy-logo-dark.svg')" alt="Logo" height="20"/>
<!--            <span style="float: right; font-size: 9px; margin-top: -4px;" >-->
<!--              <a class="text-secondary" style="color: inherit; text-decoration: inherit; text-align: right;" href="https://www.kanopy.com/en/signup/find/publiclibrary" title='kanopy' target='blank'>-->
<!--                Free access to thousands of<br>movies with your library card-->
<!--                <sup><i style="" class='fa fa-external-link'></i></sup>-->
<!--              </a>-->
<!--            </span>-->
        </StreamingFilmListCard>
      </div>

      <div class="col-xxl-3 col-lg-4 col-md-6">
        <StreamingFilmListCard provider="Hoopla" providerId="212" :hideViewedFilms="hideViewedFilms" :filterByGenres="filteredByGenres">
          <ColorThemeImg :src="logoPathTo('hoopla-logo.png')" :dark_theme_src="logoPathTo('hoopla-logo-dark.png')" alt="Logo" height="20"/>
        </StreamingFilmListCard>
      </div>

    </div>
  </div>
</template>

<script>

import ScheduledFilmListCard from "@/components/viewing options/ScheduledFilmListCard.vue";
import StreamingFilmListCard from "@/components/viewing options/StreamingFilmListCard.vue";
import {userStore} from "@/userStore";
import GenericModal from "@/components/modal/GenericModal.vue";
import axios from "axios";
import LocalTheaterFilmListCard from "@/components/viewing options/LocalTheaterFilmListCard.vue";
import analytics from "@/analytics";
import MembershipPitchCard from "@/components/purchases/MembershipPitchCard.vue";
import MembershipBannerBar from "@/components/MembershipBannerBar.vue";
import ColorThemeImg from "@/components/ColorThemeImg.vue";

export default {
  name: "DashboardPage",
  /* eslint-disable vue/no-unused-components */
  components: {
    ColorThemeImg,
    MembershipBannerBar,
    MembershipPitchCard,
    LocalTheaterFilmListCard,
    GenericModal,
    ScheduledFilmListCard,
    StreamingFilmListCard,
  },
  data() {
    return {
      show_filter_modal: false,
      hideViewedFilms: false,
      filteredByGenres: [],
      savedFilterInfo: null,
    }
  },
  watch: {
    show_filter_modal(shown) {

      if ( shown ) {
        // when the filter modal is shown, save the filter info
        this.savedFilterInfo = {
          hideViewedFilms: this.hideViewedFilms,
          filteredByGenresSaved: this.filteredByGenres.map(genre => genre)
        }
      }
    }
  },
  computed: {
    userStore() {
      return userStore;
    },
    numFiltersApplied() {
      return this.filteredByGenres.length + (this.hideViewedFilms? 1 : 0);
    },
    filterButtonText() {
      return (
          (this.numFiltersApplied > 1)? `${this.numFiltersApplied} filters applied` :
              (this.numFiltersApplied === 1)? `${this.numFiltersApplied} filter applied` :
                  'filter films'
      );
    }
  },
  methods: {
    logoPathTo(_image) {
      return `${this.$imagePathS3}logos/content-providers/large-logos/${_image}`;
    },

    toggleGenreFilter(_genre) {
      const genreIndex = this.filteredByGenres.indexOf(_genre);
      if ( genreIndex === -1 ) {
        this.filteredByGenres.push(_genre);
      } else {
        this.filteredByGenres.splice(genreIndex, 1);
      }
    },

    showFilterModal() {
      this.show_filter_modal = true;
    },
  },
  created() {
    axios.get('api/film/genres')
        .then((response) => {
          this.genreList = response.data;
        })
        .catch((err) => {
          analytics.notifyBugsnagOfError(err);
        });
  },

}
</script>


<style scoped>

  .filter-toggle {
    margin-bottom: 1em;
  }

  .btn-filter-checkbox {

    margin-bottom: 0;
    margin-right: 0.4em;
    height: 17px !important;
    width: 16px !important;

    .fa-check {
      position: absolute;
      margin-top: -3px;
      margin-left: -7px;
    }
  }

  .membership-card {
    margin-bottom: 2em;
  }

</style>